import {
    Container,
    ContainerSize,
    Form,
    FormSelectSize,
    Heading,
    Text
} from "@rebootui";
import CodeSnippet from "../../../components/controls/CodeSnippet";
import CodePreview from "../../../components/controls/CodePreview";
import CodeHighlighter from "../../../components/controls/CodeHighlighter";


type SelectPageProps = {}

const SelectPage = ({ }: SelectPageProps) => {
    return (
        <Container size={ContainerSize.Fluid}>
            {/* Select */}
            <Heading el="h1" className="fw-semibold mb-3 ls-1">
                Select
            </Heading>
            <Text className="mb-4">
                Customize the native <Text el="code">&lt;select&gt;</Text>s with custom CSS that changes the element's initial appearance.
            </Text>
            <Heading el="h2" className="fw-medium fs-3 mt-4 mb-3">
                Default
            </Heading>
            <CodeSnippet>
                <CodePreview>
                    <Form.Select aria-label="Default select example">
                        <option>Open this select menu</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                    </Form.Select>
                </CodePreview>
                <CodeHighlighter language="tsx">
                    {selectDefaultCode}
                </CodeHighlighter>
            </CodeSnippet>

            <Heading el="h2" className="fw-medium fs-3 mt-5 mb-3">
                Sizing
            </Heading>
            <CodeSnippet>
                <CodePreview>
                    <Form.Select size={FormSelectSize.Large} aria-label="Large select example" className="mb-3">
                        <option>Open this select menu</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                    </Form.Select>
                    <Form.Select size={FormSelectSize.Small} aria-label="Small select example">
                        <option>Open this select menu</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                    </Form.Select>
                </CodePreview>
                <CodeHighlighter language="tsx">
                    {selectSizingCode}
                </CodeHighlighter>
            </CodeSnippet>
        </Container>
    );
}


const selectDefaultCode = `<Form.Select aria-label="Default select example">
  <option>Open this select menu</option>
  <option value="1">One</option>
  <option value="2">Two</option>
  <option value="3">Three</option>
</Form.Select>`;

const selectSizingCode = `<Form.Select size={FormSelectSize.Large} aria-label="Large select example">
  <option>Open this select menu</option>
  <option value="1">One</option>
  <option value="2">Two</option>
  <option value="3">Three</option>
</Form.Select>
<Form.Select size={FormSelectSize.Small} aria-label="Small select example">
  <option>Open this select menu</option>
  <option value="1">One</option>
  <option value="2">Two</option>
  <option value="3">Three</option>
</Form.Select>`;


export default SelectPage;
